// <form data-controller="live-search" data-turbo-frame="entry_cards">
//   <input type="text" name="q" data-live-search-target="input" data-action="input->live-search#search">
//   <button type="button" data-action="click->live-search#clear">Clear Search</button>
// </form>
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 300)
  }

  clear() {
    clearTimeout(this.timeout)
    this.inputTarget.value = ''
    this.element.requestSubmit()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
